import StoresDataTransformer from '@/data/booking-service/StoresDataTransformer.js'

export default class StoresByCityDataTransformer {
  constructor (storesByCity) {
    this.storesByCity = storesByCity
  }

  get transformedData () {
    return this.storesByCity.map((city) => {
      return {
        name: city.city,
        slug: city.slug,
        path: 'store-location-index',
        hash: `#${encodeURIComponent(city.slug)}`,
        stores: new StoresDataTransformer(city.stores).transformedData
      }
    })
  }
}
